export default class CaseGoneError extends Error {}